import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

import { useLangLink } from '@hooks/useLangLink';
import { getMediaUrl } from '@utils/getMediaUrl';

import css from '../NavMenu.module.scss';

const NavMenuItem = ({
  index,
  itemData,
  isMobile,
  openIndex,
  setOpenIndex,
  onItemClick,
}) => {
  const { withLang } = useLangLink();

  const bodyRef = useRef(null);
  const isOpen = isMobile && index === openIndex;
  const [maxHeight, setMaxHeight] = useState('0px');

  useEffect(() => {
    if (!bodyRef.current) return;

    if (isMobile) {
      setMaxHeight(isOpen ? `${bodyRef.current.scrollHeight}px` : '0px');
    } else {
      setMaxHeight('');
    }
  }, [isMobile, isOpen]);

  const handleToggle = () => {
    if (!isMobile) return;
    setOpenIndex(isOpen ? null : index);
  };

  const { to, paragraph, children, img } = itemData;

  if (to) {
    return (
      <li>
        <NavLink to={withLang(to)} onClick={onItemClick}>
          {paragraph}
        </NavLink>
      </li>
    );
  }

  return (
    <li className={clsx(css.item__children, isOpen && css.isOpen)}>
      <p onClick={handleToggle}>{paragraph}</p>

      <div className={css.item__box}>
        <ul ref={bodyRef} style={{ maxHeight }}>
          {children.map((item, i) => (
            <li key={i}>
              <NavLink to={withLang(item.to)} onClick={onItemClick}>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        {img && (
          <div className={css.item__img}>
            <img src={getMediaUrl(img)} alt="" />
          </div>
        )}
      </div>
    </li>
  );
};

export default NavMenuItem;
